import React, { useState } from "react";
import { TouchableOpacity, Clipboard, Text } from "react-native";

const handleCopy = ({ setIsCopied, value }) => {
  setIsCopied(true);

  Clipboard.setString(value);
  setTimeout(() => setIsCopied(false), 1000);
};

export default (props) => {
  const { textStyles, value } = props;

  const [haveCopied, setIsCopied] = useState(false);

  return (
    <TouchableOpacity onPress={() => handleCopy({ setIsCopied, value })}>
      <Text selectable={true} style={textStyles}>
        {(haveCopied && "copied...") || value}
      </Text>
    </TouchableOpacity>
  );
};
